import { createSlice } from '@reduxjs/toolkit';

export interface IGrommets {
  globalFilters: Array<any>;
  filters: Object;
  filtersSelectionOrder: Array<any>;
}

const initialState: IGrommets = {
  globalFilters: [],
  filters: {},
  filtersSelectionOrder: [],
};

export const grommetsFilters = createSlice({
  name: 'grommetsFilter',
  initialState,
  reducers: {
    setGlobalFilters: (state, action) => {
      state.globalFilters = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setFiltersSelectionOrder: (state, action) => {
      state.filtersSelectionOrder = action.payload;
    },
  },
});
export const { setGlobalFilters, setFilters, setFiltersSelectionOrder } =
  grommetsFilters.actions;
export default grommetsFilters.reducer;
